export default function($) {
  $(document).ready(function () {
    $('.js-dropdown-trigger').on('click', function() {
      $(this).next('.js-dropdown-content').slideToggle('fast');
      $(this).find('.js-dropdown-icon').toggleClass('svg-rotated');
    })
  });
}
